import { useEffect, useState, useCallback } from 'react';
import { getNotificationCount, getNotifications, clearFirmNotifications } from 'services/notification/notificationService';
import Cookies from 'universal-cookie';

const cookie = new Cookies();
const useNotifications = () => {
  const [notificationCount, setNotificationCount] = useState();
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState([]);

  const getFilteredNotifications = (notifications = []) => {
    let _notifications = notifications?.filter(
      (notification) => !['client_data_changed', 'firm_deactivated', 'dashboard']?.includes(notification?.notification_type)
    );

    return _notifications;
  };

  const loadNotifications = (params) => {
    const { notificationType = '', limit = 10, nextToken = '', refresh = false, is_read = null } = params || {};
    // Only show loading state if not refreshing (refresh has its own spinner)
    if (!refresh) {
      setIsLoading(true);
    }
    return getNotifications(notificationType, limit, nextToken, 'forward', is_read)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.notifications > 0) {
          response.data.notifications = response?.data?.notifications?.filter((item) => item?.notification_type !== 'dashboard');
        }

        setNotifications((prev) => {
          let notificationsList = [...response?.data?.notifications];
          // If refresh is true or no nextToken, replace the list; otherwise append for pagination
          if (!refresh && prev?.notifications?.length && nextToken) {
            notificationsList = [...prev?.notifications, ...notificationsList];
          }
          return {
            ...response?.data,
            // notifications: [...notificationsList],
            notifications: getFilteredNotifications([...notificationsList]),
          };
        });
      })
      .catch((error) => {
        console.log('error', error);
        setIsLoading(false);
        setNotifications([]);
      });
  };
  const loadNotificationCount = useCallback((practiceAreaIds = []) => {
    getNotificationCount(practiceAreaIds)
      .then((response) => {
        setNotificationCount(response?.data);
      })
      .catch((error) => {
        console.log('error', error);
        setNotificationCount();
      });
  }, []);

  const markasRead = (sk) => {
    setNotifications((preval) => {
      return {
        ...preval?.data,
        // notifications: [...preval?.notifications?.filter((item) => item?.sk !== sk)],
        notifications: getFilteredNotifications([...preval?.notifications?.filter((item) => item?.sk !== sk)]),
        total_notifications: Number(preval?.total_notifications - 1),
      };
    });
  };

  const readFirmNotifications = (module, firm_user_id) => {
    clearFirmNotifications(module, firm_user_id)
      .then(() => {
        setTimeout(() => {
          loadNotificationCount();
        }, 5000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    let tenantId = cookie.get('tenantId');
    let tenantSk = cookie.get('tenantSk');
    if (tenantId && tenantSk) {
      loadNotifications({ is_read: false }); // Default to unread notifications
      loadNotificationCount();
    }
  }, []);

  return {
    notificationCount,
    notifications,
    isLoading,
    loadNotifications,
    loadNotificationCount,
    setNotifications,
    setNotificationCount,
    markasRead,
    getFilteredNotifications,
    readFirmNotifications,
  };
};

export default useNotifications;
